import { render, staticRenderFns } from "./VehicleReplacementBULK.vue?vue&type=template&id=2b153961&"
import script from "./VehicleReplacementBULK.vue?vue&type=script&lang=js&"
export * from "./VehicleReplacementBULK.vue?vue&type=script&lang=js&"
import style0 from "./VehicleReplacementBULK.vue?vue&type=style&index=0&id=2b153961&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports